import { createContext } from 'react';
import type { ProfilingSaveStepsTypes } from './types';

const ProfilingSaveSteps = createContext<ProfilingSaveStepsTypes>(
  {} as ProfilingSaveStepsTypes,
);

export default ProfilingSaveSteps;
